import { Button, ButtonType } from "@/components/common/button";
import { InputField } from "@/components/common/input";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";

import {
  firstNameField,
  secondNameField,
} from "@/pages/quiz/base/questions/contactField/validationRules";

type FormFieldName = "firstName" | "lastName";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  firstName: firstNameField,
  lastName: secondNameField,
};

const ContactFullName = ({
  question,
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 2;
  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <div className="w-full flex gap-4 flex-col sm:flex-row">
        <InputField {...registerField("firstName")} label="First name" />
        <InputField {...registerField("lastName")} label="Last name" />
      </div>
      <Button
        type={ButtonType.CONTINUE}
        disabled={!isFormAnswered}
        onClick={onSubmit}
      />
    </>
  );
};

export { ContactFullName };
